import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/student-daily-activities', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/student-daily-activities', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/student-daily-activities/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/student-daily-activities/${data.id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/student-daily-activities/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const classRoom = (Options = {}) => {
  return httpClient
    .get('/api/student-daily-activities/class')
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}

export const student = (Options = {}) => {
  return httpClient
    .get('/api/student-daily-activities/students', Options)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}

export const findData = (Options = {}) => {
  return httpClient
    .get('/api/student-daily-activities/find-datas', Options)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}

export const getSetting = (Options = {}) => {
  return httpClient
    .get('/api/student-daily-activities/check-setting', Options)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}

export const manualRelease = (Options = {}) => {
  return httpClient
    .get('/api/student-daily-activities/manual-releases', Options)
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  classRoom,
  student,
  findData,
  getSetting,
  manualRelease
}
